import { useAutocomplete } from 'admin';
import type { CarrierInfo } from 'api';
import { AutocompleteField } from 'form';

type Props = {
  name: string;
  label?: string;
  required?: boolean;
};

export const CarrierAutocomplete = ({ name, label = 'Select carrier', required = false }: Props) => {
  const { autocompleteProps } = useAutocomplete<CarrierInfo>({
    onSearch: (value) => [
      {
        field: 'search',
        operator: 'contains',
        value,
      },
    ],
    pagination: { pageSize: 100000 },
    resource: '/post-deal/tracker/v1/carriers/',
  });

  return (
    <AutocompleteField<CarrierInfo>
      {...autocompleteProps}
      name={name}
      label={label}
      valueField="id"
      required={required}
      getOptionLabel={(item) => (item.name ? item.name : '')}
    />
  );
};
